import React from "react";
import {Drawer, Form, Button, Col, Row, Input, Select, Space,Collapse} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {SampleAttributes} from "../../../constants";
import AgentCallScript from "./AgentCallScript";

const {Option} = Select;
const { Panel } = Collapse;

const makeCol = (row,_this) => {
    let {state,handleChangeInput,handleChangeInput2} = _this;
    if (row === null) {
        return null;
    }
    if(row.datatype==="list"){
        let options=[];
        for(let i in row.options){
            const key = i;
            const val = i;
            options.push({
                key:key,
                val:val,
            })
        }
        return(
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.fieldname}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <Select
                        placeholder={"Please enter user " + row.fieldname}
                        onChange={(e)=>handleChangeInput(e,row.fieldname)}
                    >
                        {options.map(rec =>{
                            return(
                                <Option value={rec.key}>{rec.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Col>
        )
    }
    return (
        <Col span={12}>
            <Form.Item
                name={row.fieldname}
                label={row.fieldname}
                rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
            >
                <Input
                    placeholder={"Please enter user " + row.fieldname}
                    onChange={(e)=>handleChangeInput(e.target.value,row.fieldname)}
                />
            </Form.Item>
        </Col>
    )
}

export default (props) => {
    let {_this,attributes} = props;
    let {state,handleChangeInput,handleChangeInput2} = _this;


    //let attributes = SampleAttributes();

    let ls = [];
    let loopIndex = 0;
    for (let i = 0; i < attributes.length; i += 2) {
        loopIndex = i;
        const row = attributes[i];
        let row2 = null;
        let nextIndex = i + 1;
        if(nextIndex < (attributes.length)){
            row2 = attributes[nextIndex]
        }
        ls.push(
            <Row gutter={16}>
                {makeCol(row,_this)}
                {makeCol(row2,_this)}
            </Row>
        );
        console.log("Loop ::::--> ", i, " > ", row.fieldname)
    }

    const onClose = () => {
        _this.closeNewCaseDrawer();
    }
    return (
        <>
            <Drawer
                title="Create a new account"
                width={720}
                onClose={onClose}
                visible={state.showNewCase}
                bodyStyle={{paddingBottom: 80}}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onClose} style={{marginRight: 8}}>
                            Cancel
                        </Button>
                        <Button onClick={onClose} type="primary">
                            Submit
                        </Button>
                    </div>
                }
            >

                <AgentCallScript _this={_this} />

                <Form layout="vertical" hideRequiredMark>
                    {ls.map(row=>{
                        return row;
                    })}

                </Form>
            </Drawer>
        </>
    );
}
